// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + "ReportABugPopup" + "." + "5e8890d4" + ".chunk.css";
};